export const COMPANY_PATH = "/company/:tab?";
